var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_c('app-header'),_c('intro-video'),_c('section',{staticClass:"section profile__section"},[_c('station-profile',{attrs:{"station":_vm.station}})],1),_c('shared-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }